import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { getBillStatusColor, getInvoiceProofImage } from "../functions/Bill";
import { Button, CardBody, CardFooter, Col, Row } from 'reactstrap';
import { getDateString } from '../functions/Utility';
import { getDeliveryStatusColor } from '../functions/Delivery';
import GeneralPhotoArea from './components/GeneralPhotoArea';
import { getReceiptImage } from '../functions/Receipt';
import { CardActionArea } from '@material-ui/core';

const useStyles = makeStyles({
    card: {
        display: 'flex',
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    cover: {
        minWidth: 120,
        flex: '0.4 0 auto',
    }
});




function BillRecordCard(props) {

    const { onClickCard, onUploadInvoiceProofImage, onDeleteInvoiceProofImage, onUploadReceiptImage, onDeleteReceiptImage, explicitReloadPhoto, setExplicitReloadPhoto, isCardLoading } = props;
    const classes = useStyles();
    const data = props.data;
    const paymentDate = new Date(data.paymentDateTime);
    const statusColor = getBillStatusColor(data.billStatus);

    // Control
    const [expandThisCard, setExpandThisCard] = React.useState(false);

    // Invoice photo
    //for local use
    const [invoiceProofPhotoDataBase64, setInvoiceProofPhotoDataBase64] = React.useState("");

    // Photo data Array
    // Structure: 
    // [{receiptID: XXXXXXXX, base64Data: YYYYYYYYY}, ......]
    const [receiptPhotoDataBase64Array, setReceiptPhotoDataBase64Array] = React.useState([]);







    React.useEffect(() => {
        if (expandThisCard) {
            refreshInvoicePhotoDataFromDB().then();
            refreshReceiptPhotoDataFromDB().then();
        }
    }, [expandThisCard]);

    React.useEffect(() => {
        if (expandThisCard && explicitReloadPhoto) {
            refreshInvoicePhotoDataFromDB().then(
                refreshReceiptPhotoDataFromDB().then(
                    setExplicitReloadPhoto(false)
                )
            );
        }
    }, [explicitReloadPhoto]);




    const refreshInvoicePhotoDataFromDB = async () => {
        isCardLoading(true);
        // deliveryPhoto from backend
        getInvoiceProofImage(data.paymentID).then((photoData) => {
            setInvoiceProofPhotoDataBase64(photoData.ImageBase64Content);
            isCardLoading(false);
        });

    }

    const refreshReceiptPhotoDataFromDB = async () => {

        if (data.ReceiptBillTotalMatches && Array.isArray(data.ReceiptBillTotalMatches) && data.ReceiptBillTotalMatches.length >= 1) {
            isCardLoading(true);
            let arrayToUse = data.ReceiptBillTotalMatches;
            let photoArrayToSet = [];

            for (let index = 0; index < arrayToUse.length; index++) {
                const element = arrayToUse[index];
                // from backend
                let photoData = await getReceiptImage(element.receiptID);
                photoArrayToSet.push({ receiptID: element.receiptID, base64Data: photoData.ImageBase64Content });



            };

            setReceiptPhotoDataBase64Array(photoArrayToSet);

            isCardLoading(false);
        } else {
            setReceiptPhotoDataBase64Array([]);
        }
    }

    const getReciptImageBase64ByReceiptID = (receiptID) => {

        if (receiptPhotoDataBase64Array && Array.isArray(receiptPhotoDataBase64Array) && receiptPhotoDataBase64Array.length >= 1) {
            let foundData = receiptPhotoDataBase64Array.find(item => item.receiptID === receiptID);
            if (foundData) {
                return foundData.base64Data;
            } else {
                return '';
            }
        } else {
            return '';
        }

    }

    return (
        <div className="mt-3">
            <Card className={classes.card}  >

                <CardActionArea>

                    <CardBody >
                        <Row>
                            <Col className='col-10'
                                onClick={() => { onClickCard() }} >
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    <strong className={"bg-" + statusColor + " p-1 text-dark"}>{data.billStatus}</strong>{' '}

                                    {/* {data.paymentImageCount > 0 ?
                            <strong className={"pl-2 text-success"}>
                                <i className="fas fa-file-invoice-dollar" />
                            </strong> : ""} */}

                                    {data.deliveryRecords && Array.isArray(data.deliveryRecords) &&
                                        <strong className={"bg-danger ml-1 p-1 text-dark"}>{`${data.deliveryRecords.length} 送貨`}</strong>
                                    }
                                    {data.paymentImageCount > 0 &&
                                        <strong className={"bg-success ml-1 p-1 text-dark"}>{`${data.paymentImageCount} 入數紙`}</strong>
                                    }
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    $ {data.netPrice}
                                </Typography>
                            </Col>

                            <Col className='col-2'>
                                <Button
                                    className=''
                                    color='info'
                                    onClick={() => {
                                        setExpandThisCard(!expandThisCard);
                                    }}
                                >
                                    <i className={`fa fa-caret-${expandThisCard ? "up" : "down"}`} />
                                </Button>
                            </Col>
                        </Row>

                        <Row onClick={() => { onClickCard() }}>
                            <Col>
                                <Typography variant="h5" component="h2">
                                    {data.customerName}
                                </Typography>
                                <Typography color="textSecondary">
                                    {`${getDateString(paymentDate, true, false)}`}
                                </Typography>
                                <Typography color="textSecondary">
                                    {data.goods && Array.isArray(data.goods) && data.goods.length >= 1 &&
                                        <span>
                                            {`${data.goods.map((item) => {
                                                return `${item.quantity}${item.goodUnit}${item.goodNameShortForm}`
                                            }).join(', ')}`}
                                        </span>
                                    }
                                </Typography>


                            </Col>
                        </Row>

                        {expandThisCard && <Row className='mt-2'>
                            <Col>
                                <Typography color="textSecondary">
                                    <span>自提証明：</span>
                                </Typography>
                                <GeneralPhotoArea
                                    photoID={data.paymentID}
                                    photoDataBase64={invoiceProofPhotoDataBase64}
                                    onUploadImage={async (fileToUpload) => {
                                        onUploadInvoiceProofImage(fileToUpload)
                                    }}
                                    onDeleteImage={() => {
                                        onDeleteInvoiceProofImage();
                                    }}
                                />
                            </Col>
                        </Row>}

                        <Row className='mt-1'>
                            <Col>
                                <Typography color="textSecondary">
                                    <span>付款：</span>
                                </Typography>
                                {data.ReceiptBillTotalMatches && Array.isArray(data.ReceiptBillTotalMatches) && data.ReceiptBillTotalMatches.length >= 1 &&
                                    data.ReceiptBillTotalMatches.map((receiptMatchItem, index) => {
                                        return <div key={index} onClick={() => { onClickCard() }}>
                                            <Row>
                                                <Col>
                                                    <div className='mt-1'>
                                                        <strong className={"bg-warning" + " p-1 text-dark"}>${receiptMatchItem.paidAmount}</strong>
                                                        {' '}
                                                        <strong className={"bg-info" + " p-1 text-dark"}>{receiptMatchItem.Receipt.receiptPaymentMethod}</strong>
                                                        {' '}
                                                        <strong className={"bg-info" + " p-1 text-dark"}>{receiptMatchItem.Receipt.receiptStatus}</strong>

                                                    </div>
                                                    {expandThisCard &&
                                                        <div className='mt-1'>
                                                            <strong className={"bg-info" + " p-1 text-dark"}>{receiptMatchItem.receiptID}</strong>
                                                            {' '}
                                                            <strong className={"bg-danger" + " p-1 text-dark"}>${receiptMatchItem.Receipt.receiptNetPrice}</strong>
                                                        </div>
                                                    }
                                                    {expandThisCard &&
                                                        <div className='mt-1'>
                                                            <strong className={"bg-info" + " p-1 text-dark"}>{getDateString(receiptMatchItem.Receipt.receiptRecordDateTime, true, false)}</strong>
                                                        </div>
                                                    }


                                                </Col>
                                            </Row>

                                            {expandThisCard && <Row className='mt-1'>
                                                <Col>
                                                    <Typography color="textSecondary">
                                                        <span>付款圖：</span>
                                                    </Typography>
                                                    <GeneralPhotoArea
                                                        photoID={receiptMatchItem.receiptID}
                                                        photoDataBase64={getReciptImageBase64ByReceiptID(receiptMatchItem.receiptID)}
                                                        onUploadImage={async (fileToUpload) => {
                                                            onUploadReceiptImage(receiptMatchItem.receiptID, fileToUpload)
                                                        }}
                                                        onDeleteImage={() => {
                                                            onDeleteReceiptImage(receiptMatchItem.receiptID);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>}

                                        </div>


                                    })
                                }

                            </Col>
                        </Row>

                        <Row className='mt-2' onClick={() => { onClickCard() }}>
                            <Col>
                                <Typography color="textSecondary">
                                    <span>送貨：</span>
                                </Typography>
                                {data.deliveryRecords && Array.isArray(data.deliveryRecords) && data.deliveryRecords.length >= 1 &&
                                    data.deliveryRecords.map((item, index) => {
                                        return <div key={index}>
                                            <div className='mt-2'>
                                                <strong className={"bg-" + getDeliveryStatusColor(item.deliveryStatus) + " p-1 text-dark"}>{item.deliveryStatus}</strong>
                                                {' '}
                                                <strong className={"bg-" + getDeliveryStatusColor(item.deliveryStatus) + " p-1 text-dark"}>{item.address}</strong>

                                            </div>
                                            {expandThisCard &&
                                                <div className='mt-2'>
                                                    <strong className={"bg-" + getDeliveryStatusColor(item.deliveryStatus) + " p-1 text-dark"}>{item.proposedDateTime}</strong>
                                                </div>
                                            }
                                        </div>
                                    })
                                }
                            </Col>

                        </Row>




                    </CardBody>
                </CardActionArea>
            </Card>
        </div>
    );
}

export default BillRecordCard
